import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { useShallowEqualSelector } from 'custom-hooks'
import PerfomanceEnergyItem from './PerfomanceEnergyItem'
import WhiteBlockWraper from 'components/CommonUI/WhiteBlockWraper/WhiteBlockWraper'

import {
  getPerfomanceData,
  getPerfomanceDataSelector,
  getIsFetchingPerfomance,
} from 'redux/reducers/facility'
import Title from 'components/CommonUI/Title/Title'

const perfomanseItemNames = [
  {
    title: 'Power usage',
    unit: 'kWh',
    valueField: 'power_usage',
    valuesRangeField: 'power_usage_limits',
    tooltipText:
      'Power Usage tracks your typical hourly consumption on a 30-day rolling average basis. Exceeding this range indicates higher than usual consumption, and consuming less is a sign of efficient consumption or lower than usual activity.',
  },
  {
    title: 'Total Connected Load',
    unit: 'kW',
    valueField: 'active_power',
    valuesRangeField: 'tcl_limits',
    tooltipText: 'Total Connected Load is the sum of all the equipment nameplate ratings connected to your electrical system. This percentage shows you how much of your total connected power to the utility you are actually utilizing. DEWA does not allow consumers to exceed 90% of their TCL.',
    normal: 'min',
  },
  {
    title: 'Power factor',
    unit: '',
    valueField: 'power_factor',
    valuesRangeField: 'power_factor_limits',
    tooltipText:
      'Power Factor is a ratio between real power and apparent power. It is a great tool used to show how efficiently your equipment is using power. The higher the figure, the more efficient the consumption. Values below 0.8 are considered losses.',
  },
  {
    title: 'Voltage',
    unit: 'V',
    valueField: 'voltage',
    valuesRangeField: 'voltage_limits',
    tooltipText:
      'Voltage is a key indicator of electrical performance. Significant drops or increases is often indicative of equipment performance and health.',
  },
  {
    title: 'Frequency',
    unit: 'Hz',
    valueField: 'frequency',
    valuesRangeField: 'frequency_limits',
    tooltipText:
      "Frequency is determined by the utility, and any changes to frequency is often a result of the grid's performance. This indicator rarely changes, and any significant deviation is meaningful.",
  },
]

const PerfomanceBlock = ({ id }) => {
  const dispatch = useDispatch()

  const perfomanceData = useShallowEqualSelector(getPerfomanceDataSelector)
  const isFetching = useShallowEqualSelector(getIsFetchingPerfomance)

  //console.log('perfomanceData', perfomanceData)

  useEffect(() => {
    dispatch(getPerfomanceData(id))
  }, [id, dispatch])

  return (
    <WhiteBlockWraper className="perfomance_block_container">
      <div className="perfomance_block_header">
        <Title
          title="Energy performance"
          className="perfomance_block_header_title"
          component="h3"
          withTooltip
          tooltipText="Energy Performance is an overview health check on your facility's general performance"
          style={{ fontSize: '15px' }}
        />
      </div>
      <div className="energy-performance-container">
        {!isEmpty(perfomanceData) || isFetching ? (
          perfomanseItemNames.map((item) => {
            return (
              <PerfomanceEnergyItem
                key={item.title}
                title={item.title}
                value={perfomanceData[item.valueField]}
                unit={item.unit}
                range={perfomanceData[item.valuesRangeField]}
                isFetching={isFetching}
                tooltip={item.tooltipText}
                normal={item.normal}
              />
            )
          })
        ) : (
          <div className="energy-performance-no-data">
            <span className="title">No data for today</span>
            <span className="title description">
              Need at least 2 weeks to get the information
            </span>
          </div>
        )}
      </div>
    </WhiteBlockWraper>
  )
}

export default PerfomanceBlock
